import {SUPPORT_PHONE_LABEL} from '../../../../_metronic/helpers/supportContact'

type RegisterFormHttpError = {
  response?: {
    status?: number
    data?: {code?: string; message?: string}
  }
}

// Turns a failed registerForm/save into something the visitor can act on. Only the backend's own
// coded answers carry a message meant for people; anything else (an IIS page, an ASP.NET error)
// falls back to our wording.
export const getRegisterFormSaveError = (error: unknown): string => {
  const response = (error as RegisterFormHttpError)?.response
  if (!response) {
    return 'ارتباط با سرور برقرار نشد. اینترنت خود را بررسی کنید و دوباره تلاش کنید.'
  }

  if (response.status === 403) {
    return 'تأیید امنیتی انجام نشد. صفحه را دوباره بارگذاری کنید (Ctrl+F5) و دوباره تلاش کنید.'
  }

  const data = response.data
  if (data && typeof data === 'object' && data.code && data.message) {
    return data.message
  }

  // U+2066…U+2069 isolate the number as left-to-right, or the RTL line shows «42364000-021».
  return `ثبت درخواست انجام نشد. چند لحظه بعد دوباره تلاش کنید یا با پشتیبانی به شماره \u2066${SUPPORT_PHONE_LABEL}\u2069 تماس بگیرید.`
}
